import { useMemo } from "react";
import { Route } from "~/routes/__root";

export function useSession() {
	const { session } = Route.useRouteContext();

	return { session };
}

export function useUser() {
	const { session } = useSession();

	const user = session.user;
	if (!user) {
		throw new Error("You must be authenticated");
	}

	return useMemo(() => ({ user }), [user]);
}
